import { useRef, useState } from "react";
import { useLiveSessionStore } from "../../../stores/useLiveSessionStore";
import { SessionButtonsActions } from "./SessionButtonsActions";
import "./SessionControllers.scss";
import { ToolbarActions } from "./ToolbarActions";
import { ToolbarPens } from "./ToolbarPens";

interface SessionControllersProps {
  setIsSendingEngagement: React.Dispatch<React.SetStateAction<boolean>>; // Correct type
}

export const SessionControllers = ({
  setIsSendingEngagement,
}: SessionControllersProps) => {
  const openDropdown = useLiveSessionStore((state) => state.openDropdown);
  const setOpenDropdown = useLiveSessionStore((state) => state.setOpenDropdown);
  const screenData = useLiveSessionStore((state) => state.screenData);
  const activeSlideIndex = useLiveSessionStore(
    (state) => state.activeSlideIndex
  );

  const [isObjectEraser, setIsObjectEraser] = useState(() => {
    const savedPreference = localStorage.getItem("isObjectEraser");
    return savedPreference === "true";
  });
  const [dropdownRerenderKey, setDropdownRerenderKey] = useState(0);
  const gridBtnRef = useRef<HTMLButtonElement>(null);
  const usersBtnRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="session-controllers-container">
      <div className="toolbar">
        <ToolbarActions />
        <ToolbarPens
          isObjectEraser={isObjectEraser}
          setIsObjectEraser={setIsObjectEraser}
          dropdownRerenderKey={dropdownRerenderKey}
          setDropdownRerenderKey={setDropdownRerenderKey}
        />
        <SessionButtonsActions
          openDropdown={openDropdown}
          setOpenDropdown={setOpenDropdown}
          gridBtnRef={gridBtnRef}
          usersBtnRef={usersBtnRef}
          activeSlideIndex={activeSlideIndex}
          screenData={screenData}
          setIsSendingEngagement={setIsSendingEngagement} // Correct type
        />
      </div>
    </div>
  );
};
